const initialState = {
  urls: {
    data: [],
    loading: false,
    error: null,
  },
  createTinyUrl: {
    data: '',
    loading: false,
    error: null,
  },
};

export default initialState;
